﻿import $ from 'jquery';

export class Url {
  public get protocol(): string { return this.options.protocol; }
  public get host(): string { return this.options.host; }
  public get port(): string { return this.options.port; }
  public get path(): string { return this.options.path; }
  public get queryParameters(): any { return this.options.queryParameters; }
  public get hash(): string { return this.options.hash; }

  private DEFAULTS: IUrlOptions = {
    protocol: '',
    host: '',
    port: '',
    path: '',
    queryParameters: {},
    hash: ''
  };

  private options: IUrlOptions;

  constructor(url?: string, options?: IUrlOptions) {
    if (url)
      options = this.parseUrl(url);

    this.options = $.extend({}, this.DEFAULTS, options);

    if (!this.options.queryParameters)
      throw new Error('queryParameters cannot be null');
  }

  public setProtocol(protocol: string): Url {
    if (protocol) {
      protocol = protocol.replace(':', '');
      protocol = protocol.replace('/', '');
    }

    this.options.protocol = protocol;

    return this;
  }

  public setHost(host: string): Url {
    this.options.host = host;

    return this;
  }

  public setPort(port: string): Url {
    if (port && !/^\d+&/.test(port))
      throw new Error('port must be an integer');

    this.options.port = port;

    return this;
  }

  public setPath(path: string): Url {
    if (path && path.charAt(0) != '/')
      path = '/' + path;

    this.options.path = path;

    return this;
  }

  public setQueryParameter(key: string, value: string | Array<string>): Url {
    if (!key)
      throw new Error('key cannot be null');

    let valuesArray: Array<string>;
    if (!(value instanceof Array))
      valuesArray = [value];
    else
      valuesArray = value;

    let encodedValues = valuesArray.map(x => encodeURIComponent(x));

    this.options.queryParameters[key] = encodedValues.join('&' + key + '=');

    return this;
  }

  public removeQueryParameter(key: string): Url {
    if (!key)
      throw new Error('key cannot be null');

    delete this.options.queryParameters[key];

    return this;
  }

  public getQueryParameter(key: string): string {
    if (!key)
      throw new Error('key cannot be null');

    return this.options.queryParameters[key];
  }

  public setHash(hash: string): Url {
    if (hash)
      hash.replace('#', '');

    this.options.hash = hash;

    return this;
  }

  public toUrl(): string {
    let url = '';

    if (this.protocol)
      url = this.protocol + '://';

    if (this.host)
      url = url + this.host;

    if (this.port)
      url = url + ':' + this.port;

    if (this.path)
      url = url + this.path;

    let querystring = this.createQueryString();
    if (querystring)
      url = url + '?' + querystring.substring(1);

    if (this.hash)
      url = url + '#' + this.hash;

    return url;
  }

  private parseUrl(url: string): IUrlOptions {
    let result = <IUrlOptions>{};
    let a = document.createElement('a');
    a.href = url;

    result.protocol = a.protocol.replace(':', '');
    result.host = a.hostname;
    result.port = a.port;
    result.path = a.pathname;
    result.queryParameters = this.getQueryParameters(a.search);
    result.hash = a.hash.replace('#', '');

    if (result.path && result.path.charAt(0) != '/')
      result.path = '/' + result.path;

    return result;
  }

  private getQueryParameters(queryString: string): any {
    if (!queryString)
      return {};

    if (queryString.charAt(0) === '?')
      queryString = queryString.substring(1);

    let queryParams = queryString.split('&');

    let result = {};
    queryParams.map(function (value: string) {
      let pair = value.split('=');
      result[pair[0]] = pair[1];
    });

    return result;
  }

  private createQueryString(): string {
    let self = this;
    let querystring = '';

    Object.keys(this.queryParameters).forEach(function (key) {
      querystring = querystring + '&' + key + '=' + self.queryParameters[key]
    });

    return querystring;
  }
}

export interface IUrlOptions {
  protocol?: string;
  host?: string;
  port?: string;
  path?: string;
  queryParameters?: any;
  hash?: string;
}

export default Url;
